import { render, staticRenderFns } from "./AboutDivas.vue?vue&type=template&id=3c369aa8&scoped=true&"
import script from "./AboutDivas.vue?vue&type=script&lang=js&"
export * from "./AboutDivas.vue?vue&type=script&lang=js&"
import style0 from "./AboutDivas.vue?vue&type=style&index=0&id=3c369aa8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c369aa8",
  null
  
)

export default component.exports